var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3335 20C15.8563 20 20.3335 15.5228 20.3335 10C20.3335 4.47715 15.8563 0 10.3335 0C4.81065 0 0.333496 4.47715 0.333496 10C0.333496 15.5228 4.81065 20 10.3335 20Z",
    fill: "#3C63B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99902 13.1868L6.28092 10.485C6.20497 10.4091 6.16699 10.3114 6.16699 10.192C6.16699 10.0727 6.20497 9.97504 6.28092 9.89908L6.88314 9.31315C6.95909 9.22634 7.05403 9.18294 7.16797 9.18294C7.2819 9.18294 7.38227 9.22634 7.46907 9.31315L9.29198 11.1361L13.1982 7.22982C13.285 7.14301 13.3854 7.09961 13.4993 7.09961C13.6133 7.09961 13.7082 7.14301 13.7842 7.22982L14.3864 7.81575C14.4623 7.89171 14.5003 7.98936 14.5003 8.10872C14.5003 8.22808 14.4623 8.32573 14.3864 8.40169L9.58495 13.1868C9.509 13.2736 9.41134 13.317 9.29198 13.317C9.17263 13.317 9.07497 13.2736 8.99902 13.1868Z",
    fill: "#3C63B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesIcon);
export default __webpack_public_path__ + "static/media/yes-icon.fd9c4cf2a33d3eee0d591d432eb68a34.svg";
export { ForwardRef as ReactComponent };